import {createStore} from "vuex";
import help from "../assets/js/help.js";
export default createStore({
  state: {
    isTest: false,
    uid: "",
    token: "",
    time: "",
    phone: "",
    type: "",
    activeIndex: 0,
    isSelected: "",
    homeReset: false,
    totalIngral: 0,
    loadingBanner: true,
    shareTitle: "",
    shareDesc: "",
    shareImage: "",
    bannerImage: "",
  },
  mutations: {
    login(state, info = {provider: "", phone: ""}) {
      console.log("login");
      state.hasLogin = true;
      state.loginProvider = info.provider;
      state.phone = info.phone;
      let str = info.phone;
      state.phoneReset = str.substr(0, 3) + "****" + str.substr(7);
    },
    logout(state) {
      state.hasLogin = false;
      state.openid = null;
    },
    setTimeOut(state, data = false) {
      state.isTimeOuted = data;
    },
    setTotalIngral(state, num) {
      state.totalIngral = num;
      help.setStorage("totalIngral", num);
    },
    setUid(state, id) {
      state.uid = id;
      //help.setStorage("uid", id);
    },
    setIsSelected(state, id) {
      state.isSelected = id;
    },
    setType(state, id) {
      state.type = id;
    },
    setActiveIndex(state, id) {
      state.activeIndex = id;
    },
    setHomeReset(state, id) {
      state.homeReset = id;
    },
    setToken(state, Token) {
      state.token = Token;
      //help.setStorage("token", id);
    },
    setAppInfo(state, info = {uid: "", token: "", time: "", phone: ""}) {
      //console.log(info);
      if (!info.uid) {
        console.log("置空");
        state.uid = "";
        state.token = "";
        state.time = "";
        state.phone = "";
        hasValue = false;
      } else {
        state.uid = info.uid;
        state.token = info.token;
        state.time = info.time;
        state.phone = info.phone;
        console.log("vuex");
      }
    },
    setShareInfo(state, info = {shareTitle: "", shareDesc: "", shareImage: "", bannerImage: ""}) {
      console.log(info);
      state.shareTitle = info.shareTitle;
      state.shareDesc = info.shareDesc;
      state.shareImage = info.shareImage;
      state.bannerImage = info.bannerImage;
      state.loadingBanner = false;
    },
    setInvited(state, info = {length: ""}) {
      console.log(info);
      state.invitedListLength = info.length;
      state.invitedLoading = false;
    }
  },
  getters: {
    currentColor(state) {
      return state.colorList[state.colorIndex];
    }
  },
  actions: {
    // lazy loading openid
    getUserOpenId: async function ({
                                     commit,
                                     state
                                   }) {
      return await new Promise((resolve, reject) => {
        if (state.openid) {
          resolve(state.openid);
        } else {
          uni.login({
            success: (data) => {
              commit("login");
              setTimeout(function () { //模拟异步请求服务器获取 openid
                const openid = "123456789";
                console.log("uni.request mock openid[" + openid + "]");
                commit("setOpenid", openid);
                resolve(openid);
              }, 1000);
            },
            fail: (err) => {
              console.log("uni.login 接口调用失败，将无法正常使用开放接口等服务", err);
              reject(err);
            }
          });
        }
      });
    }
  }
});
